export default "__VITE_ASSET__BaOUAtA3__"